import React from 'react'
import Sidebar from '../component/Sidebar'
import Chatbar from '../component/Chatbar'

const Home = () => {
  return (
    <div className='chat-page'>
        <div className="chat-layout">
          <Sidebar/>
          <Chatbar/>
        </div>
    </div>
  )
}

export default Home;
